import React, { useContext, useState } from "react";
import styled from "styled-components";
import { UserContext } from "../../../contexts/UserContext";
import { Colors } from "../../../theme/colors";
import Button from "../../atoms/Button";
import Separator from "../../atoms/Separator";
import Text from "../../atoms/Text";
import ModalInfo from "../../molecules/ModalInfo";
import InfoFullPageTemplate from "../../templates/InfoFullPageTemplate";
import { v4 as uuidv4 } from "uuid";
import { assignDeviceId } from "../../../apis/User";
import UserAPI from "../../../apis/UserAPI";
import { useHistory } from "react-router-dom";

const InfoAssignDevicePage = () => {
  let history = useHistory();

  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);

  const [isAssigning, setIsAssigning] = useState<boolean>(false);

  const userContext = useContext<{
    id?: string;
    name?: string;
    lastname?: string;
    email?: string;
    createdAt?: number;
  }>(UserContext);

  const name = userContext.name || userContext.lastname || userContext.email;

  const handleOnAssignDevice = async () => {
    try {
      if (userContext.id !== undefined) {
        setIsAssigning(true);
        const randomId = uuidv4();
        localStorage.setItem(`SEED_${userContext.id}`, randomId);
        await assignDeviceId(randomId, userContext.id);
        setIsAssigning(false);
        setShowConfirmationModal(false);
        history.push('/home');
      }
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <>
      <ModalInfo
        isOpen={showConfirmationModal}
        onRequestClose={() => setShowConfirmationModal(false)}
        title="¿Estás seguro de asignar el dipositivo actual?"
        message="Recuerda que este proceso se debe hacer desde tu dispositivo personal."
        actions={
          <>
            <Button
              type="primary-inverted"
              label="No"
              onClick={() => setShowConfirmationModal(false)}
            />
            <Button
              loading={isAssigning}
              type="primary"
              label="Sí, asignar"
              onClick={handleOnAssignDevice}
            />
          </>
        }
      />
      <InfoFullPageTemplate
        title={`${
          name !== undefined ? `Hola, ${name}.\n` : ""
        }Asigna un dispostivo a tu cuenta.`}
        footer={
          <>
            <Button
              type="primary"
              label="Asignar"
              onClick={() => setShowConfirmationModal(true)}
            />
            <Separator type="small" />
            <Button
              type="primary-inverted"
              label="Cerrar sesión"
              onClick={() => {
                UserAPI.logout();
                history.push("/login");
              }}
            />
          </>
        }
      >
        <Text type="p">
          Hemos detectado que aún no has asignado tu dispositivo personal a tu
          cuenta.
        </Text>
        <Separator type="medium" />
        <Text type="p">
          Si te encuentras en tu dispositivo personal, dale click en "Asignar".
        </Text>
        <Separator type="medium" />
        <Text type="p">
          Si este no es tu dispositivo personal, entra primero desde tu
          dispositivo personal para poder asignarlo.
        </Text>
      </InfoFullPageTemplate>
    </>
  );
};

const StepWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const StepNumber = styled(Text)`
  min-width: 30px;
`;

export default InfoAssignDevicePage;
